import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import CanvasIcon from "@/icons/ProvidersIcons/CanvasIcon";
import ClassLinkIcon from "@/icons/ProvidersIcons/ClassLinkIcon";
import GoogleClassIcon from "@/icons/ProvidersIcons/GoogleClassIcon";
import SchoologyIcon from "@/icons/ProvidersIcons/SchoologyIcon";
import {
  assigneeTypeTitleCss,
  classlistContainerCss,
  sgaCheckboxStyles,
  sgaClasslistItemCss,
} from "../../assignments/AssignmentEditor/AssigneeSelectorModal/AssigneeSelectorModal.style";

const propTypes = {
  /**
   * Array of classroom options for a user to select.
   */
  classroomChoices: PropTypes.array,
  /**
   * Array of checked classrooms the user has selected.
   */
  stagedClassroomSelection: PropTypes.array,
  /**
   * Function to fire to update staged selection of classrooms.
   */
  setStagedClassroomSelection: PropTypes.func,
  setStagedStudentAssigneeSelection: PropTypes.func,
};

/**
 * ClassroomSelection displays a list of classrooms, and allows
 * the list to be modified via checkboxes. A callback must
 * be provided to update the previouslySelectedClassrooms array prop.
 */
const ClassroomSelectionSGA = ({
  classroomChoices,
  stagedClassroomSelection,
  setStagedClassroomSelection,
  setStagedStudentAssigneeSelection,
}) => {
  const manageCheckboxClick = (classroomChoice) => {
    const isChecked = stagedClassroomSelection.find(
      (stagedClassroom) => stagedClassroom.id === classroomChoice.id,
    );
    if (isChecked) {
      const filteredStagedClassroomSelection = stagedClassroomSelection.filter(
        (currentlySelected) => {
          return currentlySelected.id !== classroomChoice.id;
        },
      );
      setStagedClassroomSelection([...filteredStagedClassroomSelection]);
    } else {
      setStagedStudentAssigneeSelection([]);
      setStagedClassroomSelection((prevStagedClassroomsArray) => [
        ...prevStagedClassroomsArray,
        classroomChoice,
      ]);
    }
  };

  const renderIcons = (classroomChoice) => {
    switch (classroomChoice.provider) {
      case "google_classroom":
        return (
          <GoogleClassIcon role="img" title="Imported from Google Classroom" />
        );
      case "canvas":
        return <CanvasIcon role="img" title="Imported from Canvas" />;
      case "schoology":
        return <SchoologyIcon role="img" title="Imported from Schoology" />;
      case "classlink":
        return <ClassLinkIcon role="img" title="Imported from ClassLink" />;
      case "otus":
        return <span> Otus </span>;
      case "oneroster":
        return <span> Oneroster</span>;
      case "itslearning":
        return <span> Itslearning </span>;
      case "desire2learn":
        return <span> Desire2learn </span>;
      case "imgslc":
        return <span> Imsglc </span>;
      case "clever":
        return <span> Clever </span>;
      default:
        break;
    }
  };

  return (
    <>
      <h3 css={assigneeTypeTitleCss}>Choose 1 or more classes:</h3>
      <ul css={classlistContainerCss}>
        {classroomChoices?.map((classroomChoice) => {
          const isChecked = !!stagedClassroomSelection?.find(
            (selectedClassroom) => {
              return selectedClassroom.id === classroomChoice.id;
            },
          );
          return (
            <li key={classroomChoice.id} css={sgaClasslistItemCss}>
              <Checkbox
                __cssFor={{
                  root: sgaCheckboxStyles,
                }}
                checked={isChecked}
                label={classroomChoice.name}
                name="class"
                value={classroomChoice.name}
                withContainer
                onClick={() => manageCheckboxClick(classroomChoice)}
              />

              {renderIcons(classroomChoice)}
            </li>
          );
        })}
      </ul>
    </>
  );
};

ClassroomSelectionSGA.propTypes = propTypes;

export default ClassroomSelectionSGA;
